/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye-alt': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 11',
    data: '<path pid="0" d="M7.6 0c3.484 0 6.524 2.156 7.563 5.365.05.153.05.317 0 .47-1.04 3.21-4.08 5.365-7.564 5.365S1.075 9.044.037 5.835a.764.764 0 010-.47C1.076 2.156 4.117 0 7.599 0zm0 1.513c-2.754 0-5.168 1.643-6.066 4.052.898 2.479 3.312 4.122 6.065 4.121 2.756 0 5.17-1.643 6.067-4.052-.9-2.479-3.312-4.121-6.067-4.121zm2.777 4.079c0 1.544-1.246 2.8-2.778 2.8-1.533 0-2.78-1.257-2.78-2.8a.696.696 0 111.389 0c0 .774.625 1.404 1.391 1.404s1.39-.63 1.39-1.404c0-.774-.624-1.403-1.39-1.403a.696.696 0 01-.694-.698c0-.386.31-.699.694-.699 1.532.001 2.778 1.257 2.778 2.8z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
